export default "__VITE_ASSET__ecf61b4b__"